import React from "react";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { CheckCircle, RadioButtonUnchecked } from "@mui/icons-material";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { selectStatusLabels } from "../../redux/slices/statusDefinitionsSlice";

dayjs.extend(relativeTime);

const ShipmentTimeline = ({ statusHistory = [] }) => {
  const statusLabels = useSelector(selectStatusLabels("shipment"));
  if (!statusHistory.length) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ p: 2.5 }}>
        No status history yet.
      </Typography>
    );
  }

  const sorted = [...statusHistory].sort(
    (a, b) => new Date(b.timestamp) - new Date(a.timestamp),
  );

  return (
    <Box
      sx={{ px: 2.5, py: 2, display: "flex", flexDirection: "column", gap: 0 }}
    >
      {sorted.map((entry, idx) => (
        <Box key={idx} sx={{ display: "flex", gap: 1.5, position: "relative" }}>
          {idx < sorted.length - 1 && (
            <Box
              sx={{
                position: "absolute",
                left: 11,
                top: 26,
                width: 2,
                height: "calc(100% - 10px)",
                bgcolor: idx === 0 ? "primary.main" : "divider",
              }}
            />
          )}

          <Box sx={{ flexShrink: 0, mt: 0.5, zIndex: 1 }}>
            {idx === 0 ? (
              <CheckCircle sx={{ fontSize: 24, color: "primary.main" }} />
            ) : (
              <RadioButtonUnchecked
                sx={{ fontSize: 24, color: "text.disabled" }}
              />
            )}
          </Box>

          <Box sx={{ pb: 2.5, flex: 1, minWidth: 0 }}>
            <Typography
              sx={{
                fontSize: 13,
                fontWeight: 700,
                color: idx === 0 ? "primary.main" : "text.primary",
              }}
            >
              {statusLabels[entry.status] || entry.status}
            </Typography>
            {entry.note && (
              <Typography
                variant="caption"
                color="text.secondary"
                display="block"
                mt={0.25}
              >
                {entry.note}
              </Typography>
            )}
            <Typography
              variant="caption"
              color="text.disabled"
              display="block"
              mt={0.5}
            >
              {dayjs(entry.timestamp).format("MMM D, YYYY [at] h:mm A")}
              {entry.updatedBy &&
                ` · ${entry.updatedBy.firstName} ${entry.updatedBy.lastName}`}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default ShipmentTimeline;